 <!-- coperbizitravelonlineaktarim.vue -->

<template>
  <div>
    <baseaktarim
      :logo="null"
      :title="this.$t('Bizi-Travel-Hotel-Transfer')"
      v-model="items"
      v-on:aktar="Aktar"
      :status="status"
      :tarihfield="true"
      :menuitems="menuItems"
      v-on:menuclick="menuClick"
    >
    <template slot="toolbar">
      <v-flex xs12 sm6 md2>
                 
        <v-text-field
                hide-details
                label="Customer Id"
                v-model="customerId"
              >
              </v-text-field >

                </v-flex>
      
    </template>

    </baseaktarim>
    <v-dialog
      v-model="dialogayarlar"
      scrollable=""
      persistent=""
      max-width="400px"
    >
      <v-card color="grey lighten-5">
        <v-card-title> Parametreler </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                label="report_url"
                v-model="BokingAgoraAyar.report_url"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                label="api_client_key"
                v-model="BokingAgoraAyar.api_client_key"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                label="api_client_secret"
                v-model="BokingAgoraAyar.api_client_secret"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                label="api_client_organization_id"
                v-model="BokingAgoraAyar.api_client_organization_id"
              >
              </v-text-field>
            </v-flex>
           
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="dialogayarlar = false"
            >{{ $t("cancel_button") }}</v-btn
          >
          <v-btn color="blue darken-1" flat @click.native="ayarkaydet()">{{
            $t("save_button")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import baseaktarim from "../aktarim/coperbaseaktarim";
import tool from "../tools";
import helpers from "@/components/app/customcomp/helpers.js";

export default {
  data() {
    return {
      items: [],
      status: tool.NewSatatus(),
      dialogayarlar: false,
      customerId:'',
      
       BokingAgoraAyar: {
        report_url: null,
        api_client_key: null,
        api_client_secret: null,
        api_client_organization_id: null,
        },
      menuItems: [
        {
          title: this.$t('Parameters'),
        },
      ],
    };
  },

  components: {
    baseaktarim,
  },
  methods: {
     ParametreOku: ParametreOku,
    menuClick(index) {
      if (index == 0) {
        this.ParametreOku();
      } else if (index == 1) {
      }
    },
    Aktar(date) {

      let params = {
        tarih: date,
        customerId:this.customerId
      };

      this.status.loading = true;
      tool.api_post(this, "CoperStream/BizitravelOnlineStream", params).then(
        (response) => {
          this.items = response.body;
          this.status.loading = false;
        },
        (response) => {
          this.status = tool.responseToStatus(response);
        }
      );
    },
    ayarkaydet() {
      let params = this.BokingAgoraAyar;

      tool
        .api_post(this, "CoperStream/BiziTravelParametreWrite", params)
        .then(
          (response) => {
            if (response.body === true) {
              this.text1 = this.$t("Your-settings-have-been-saved");
              this.snackbar = true;
              this.dialogayarlar = false;
            } else {
              this.text1 = this.$t("Error-please-try-again");
              this.snackbar = false;
            }
          },
          (response) => {
            this.text1 = this.$t("Error-please-try-again");
            this.snackbar = false;
          }
        );
    },
  },
};

 function ParametreOku() {
    tool.api_post(this, 'CoperStream/BiziTravelParametreRead', {}).then((response) => {

      this.BokingAgoraAyar = response.body
     
      this.dialogayarlar = true
    }, (response) => {

      this.text1 = "Ayarlar getirilemedi tekrar deneyiniz."
      this.snackbar = false
    })
  }

</script>
